import ButtonGroup from '../shared/buttons/button-group';
import NavLink from '../shared/buttons/nav-link';
import PropTypes from 'prop-types';

function TopStudentScoreTab(props) {
  const { rankType } = props;

  return (
    <ButtonGroup className='mx-auto mb-6 w-min'>
      <NavLink to='/top-student-scores/weekly/1' color={rankType === 'weekly' ? 'indigo' : 'gray'}>
        هفتگی
      </NavLink>
      <NavLink
        to='/top-student-scores/monthly/1'
        color={rankType === 'monthly' ? 'indigo' : 'gray'}
      >
        ماهانه
      </NavLink>
    </ButtonGroup>
  );
}

TopStudentScoreTab.propTypes = {
  rankType: PropTypes.string.isRequired
};

export default TopStudentScoreTab;
